import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "./styles/DropdownMenu.css";

const DropdownMenu = ({ title, items }) => {
  const [isOpen, setIsOpen] = useState(false);

  const isGrouped = items && !Array.isArray(items) && typeof items === "object";

  const groups = isGrouped
    ? [
        { heading: "Managed Services",                          list: items.managedServices || [] },
        { heading: "Infrastructure Services",                   list: items.infrastructureServices || [] },
        { heading: "IT Consulting & Professional Services",     list: items.ITConsultingAndProfessionalServices || [] },
        { heading: "Talent Services",                           list: items.TalentServices || [] },
      ]
    : [{ heading: null, list: items || [] }];

  return (
    <div
      className="dropdown"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <button className="dropdown__trigger" aria-expanded={isOpen} aria-haspopup="true">
        {title}
        <svg
          className={`dropdown__arrow ${isOpen ? "dropdown__arrow--open" : ""}`}
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          aria-hidden="true"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.18 }}
            className="dropdown__menu"
            role="menu"
          >
            {groups.map((g, gi) => (
              <div key={g.heading || gi} className="dropdown__group">
                {g.heading && (
                  <p className="dropdown__title" aria-hidden="true">
                    {g.heading}
                  </p>
                )}

                {g.list.map((item, index) => (
                  <Link
                    key={`${item.href}-${index}`}
                    to={item.href}
                    className="dropdown__item"
                    role="menuitem"
                  >
                    {item.label}
                  </Link>
                ))}

                {gi !== groups.length - 1 && (
                  <div className="dropdown__divider" aria-hidden="true" />
                )}
              </div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default DropdownMenu;
